import { Outlet, Navigate } from "react-router-dom";
import { useMe } from "../hooks/useApi";
import { useTheme } from "../hooks/useTheme";

const features = [
  "مدیریت کلیدهای API و احراز هویت امن",
  "اتصال به ده‌ها مدل هوش مصنوعی با یک API واحد",
  "کیف پول، اشتراک و بیلینگ شفاف",
  "گزارش‌گیری و تحلیل لحظه‌ای مصرف",
];

export default function AuthLayout() {
  const { data: user, isLoading } = useMe();
  const { theme } = useTheme();

  // If authenticated, redirect to dashboard
  if (!isLoading && user) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div data-theme={theme} className="min-h-screen md:flex">
      {/* Branding panel (desktop only) */}
      <aside className="auth-branding-bg hidden md:flex md:w-[46%] xl:w-1/2 relative overflow-hidden items-center justify-center px-12 py-16">
        {/* Decorative circles */}
        <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-white/5" />
        <div className="absolute -bottom-20 -left-20 w-56 h-56 rounded-full bg-white/5" />
        <div className="absolute top-1/3 left-1/4 w-40 h-40 rounded-full bg-white/5" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[28rem] h-[28rem] rounded-full bg-primary-light/20 blur-3xl" />

        <div className="relative z-10 max-w-md text-right">
          <div className="flex items-center gap-3 mb-8">
            <img src="/logo-reverse-filled.svg" alt="ASHA-AI" className="w-12 h-12" />
            <div>
              <h1 className="text-2xl font-bold text-white leading-tight">ASHA-AI</h1>
              <p className="text-sm text-white/70">AI Gateway</p>
            </div>
          </div>

          <h2 className="text-3xl xl:text-4xl font-bold text-white leading-tight mb-4">
            درگاه هوش مصنوعی شما
          </h2>
          <p className="text-lg text-white/80 leading-relaxed mb-10">
            مدیریت یکپارچه مدل‌های هوش مصنوعی، کلیدهای API و مصرف در یک پلتفرم امن و سریع
          </p>

          <div className="space-y-4">
            {features.map((feature, i) => (
              <div key={i} className="flex items-center gap-3 text-white/85">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" className="text-white/70 shrink-0">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                <span>{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </aside>

      {/* Form area (mobile: centered card / desktop: right panel) */}
      <main className="min-h-screen flex items-center justify-center bg-surface-base p-4 md:flex-1 md:min-h-0 md:p-8">
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </main>
    </div>
  );
}